export type DualListItem = {
  id: string;
  label: string;
  group?: string;
};

export interface DualListLabels {
  searchPlaceholder?: string;
  defaultGroup?: string;
  availableTitle?: string;
  availableSubtitle?: string;
  selectedTitle?: string;
  selectedSubtitle?: string;
  selectAll?: string;
  clearAll?: string;
  emptyAvailableTitle?: string;
  emptyAvailableDescription?: string;
  emptySelectedTitle?: string;
  emptySelectedDescription?: string;
  footerTip?: string;
  cancel?: string;
  save?: string;
}

export const DEFAULT_DUAL_LIST_LABELS: Required<DualListLabels> = {
  searchPlaceholder: 'Pesquisar por nome...',
  defaultGroup: 'Itens',
  availableTitle: 'Disponíveis',
  availableSubtitle: 'Selecione um ou vários itens',
  selectedTitle: 'Selecionados',
  selectedSubtitle: 'Remova rapidamente o que não pertence',
  selectAll: 'Selecionar filtrados',
  clearAll: 'Limpar tudo',
  emptyAvailableTitle: 'Nenhum item encontrado',
  emptyAvailableDescription: 'Tente outro termo de busca.',
  emptySelectedTitle: 'Nenhum item selecionado',
  emptySelectedDescription: 'Escolha itens da coluna à esquerda.',
  footerTip: 'Dica: clique em um item para adicionar ou remover.',
  cancel: 'Cancelar',
  save: 'Salvar alterações',
};
